import {
  NBS_WS_GET_CHAT_HISTORY,
  NBS_WS_GET_CHAT_HISTORY_SUCCESS,
  NBS_WS_SEND_MESSAGE,
  NBS_WS_SEND_MESSAGE_SUCCESS,
  NBS_WS_SEND_MESSAGE_FAIL,
  NBS_WS_GET_MESSAGE_SUCCESS
} from '../../constants/actions';
import { convertMessagesArrayToObject } from '../../assets/helpers/messagesHelper';

const initialState = {
  sendError: {},
  sendErrorEvent: false,
  fetchError: false,
  usersMessages: {} // {[user_id]: {[message_id]: {data}, [message_id_2]: {data2}, ...}}
};

export default function messages (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_WS_GET_CHAT_HISTORY_SUCCESS:
      // done
      let userHistoryMessages = state.usersMessages[action.data['user_id']] ? {...state.usersMessages[action.data['user_id']]} : {};
      let userNewHistoryMessages = convertMessagesArrayToObject(action.data.messages);
      let combinedHistoryMessages = {...userHistoryMessages, ...userNewHistoryMessages};
      return {
        ...state,
        fetchError: false,
        usersMessages: {...state.usersMessages, ...{[action.data['user_id']]: combinedHistoryMessages}}
      };
    case NBS_WS_GET_MESSAGE_SUCCESS:
      // console.log('SEND MESSAGE RECIVED', action);
      let userGetMessages = state.usersMessages[action.data['user_id']] ? {...state.usersMessages[action.data['user_id']]} : {};
      let newGetMessage = {[action.data.mid]: {...action.data, ...{ out: false }}}; // direction=0 is for receiveMessages
      let newUserGetMessages = {...userGetMessages, ...newGetMessage};
      return {
        ...state,
        fetchError: false,
        usersMessages: {...state.usersMessages, ...state.userGetMessages, ...{[action.data['user_id']]: newUserGetMessages}}
      };
    case NBS_WS_SEND_MESSAGE_SUCCESS:
      // console.log('SEND MESSAGE RECIVED', action);
      let userMessages = state.usersMessages[action.data['user_id']] ? {...state.usersMessages[action.data['user_id']]} : {};
      let newMessage = {[action.data.mid]: {...action.data, ...{ out: true }}}; // direction=1 is for sendMessages
      let newUserMessages = {...userMessages, ...newMessage};
      return {
        ...state,
        sendError: false,
        usersMessages: {...state.usersMessages, ...{[action.data['user_id']]: newUserMessages}}
      };
    case NBS_WS_GET_CHAT_HISTORY:
      return {
        ...state,
        fetchError: false
      };
    case NBS_WS_SEND_MESSAGE_FAIL:
      return {
        ...state,
        sendErrorEvent: action.data.event,
        sendError: action.data
      };
    case NBS_WS_SEND_MESSAGE:
      return {
        ...state,
        sendError: false
      };
    default:
      return state;
  }
}
